// Centralized configuration for Dejavoo DvPayLite deeplinks (URI mode)
// Per docs (URI Mode): scheme is "denovopay" and URL shape is:
// denovopay://<host>?data=<url-encoded JSON>
// Hosts vary by API (register, pay, get).

export const DEJAVOO_SCHEME = 'denovopay';

// Our callback URI pieces: bluapp://callback/dejavoo?requestId=...&status=...&payload=...
export const CALLBACK_SCHEME = 'bluapp';
export const CALLBACK_HOST = 'callback';
export const CALLBACK_PATH_PREFIX = '/dejavoo';

export const buildCallbackUrl = (params = {}) => {
	// Build bluapp://callback/dejavoo?...
	const usp = new URLSearchParams(params);
	return `${CALLBACK_SCHEME}://${CALLBACK_HOST}${CALLBACK_PATH_PREFIX}?${usp.toString()}`;
};

// Enumerate available actions we want to test in PoC
export const DejavooActions = {
	DeviceRegister: 'deviceRegister',
	GetTPN: 'getTpn',
	DeviceDetail: 'deviceDetail',
	Sale: 'sale',
	Refund: 'refund',
	Void: 'void',
	BatchClose: 'batchClose',
	Status: 'status'
};

// Map actions to URI host and base parameters (mock values where needed)
// Note: data must be URL-encoded JSON per docs.
export const ActionTemplates = {
	[DejavooActions.DeviceRegister]: {
		path: 'register',
		params: (() => {
			const payload = {
				tpn: '123456789012',
				applicationType: 'DVPAYLITE'
			};
			return { data: JSON.stringify(payload) };
		})()
	},
	[DejavooActions.GetTPN]: {
		path: 'get',
		params: (() => {
			const payload = {
				applicationType: 'DVPAYLITE',
				type: 'getTPN'
			};
			return { data: JSON.stringify(payload) };
		})()
	},
	[DejavooActions.DeviceDetail]: {
		path: 'get',
		params: (() => {
			const payload = {
				applicationType: 'DVPAYLITE',
				type: 'getDevice'
			};
			return { data: JSON.stringify(payload) };
		})()
	},
	[DejavooActions.Sale]: {
		path: 'pay',
		params: (() => {
			const payload = {
				type: 'SALE',
				paymentType: 'CREDIT',
				amount: '10.00',
				tip: '0.00',
				applicationType: 'DVPAYLITE',
				refId: 'INV-POC-001',
				receiptType: 'No',
				isTxnStatusScreenRequired: 'No',
				showTipScreen: 'No',
				showBreakupScreen: 'No',
				showDualPriceScreen: 'No',
				customUI: {
					fontFamily: 'Inter',
					primaryColor: '1976d2',
					secondaryColor: '1d1d1d',
					negativeButtonColor: 'e74c3c',
					removeLoaderLogo: 'YES',
					requiredAvs: 'NO'
				}
			};
			return { data: JSON.stringify(payload) };
		})()
	},
	[DejavooActions.Refund]: {
		path: 'pay',
		params: (() => {
			const payload = {
				type: 'REFUND',
				paymentType: 'CREDIT',
				amount: '5.00',
				applicationType: 'DVPAYLITE',
				refId: 'REF-POC-001',
				receiptType: 'No'
			};
			return { data: JSON.stringify(payload) };
		})()
	},
	[DejavooActions.Void]: {
		path: 'pay',
		params: (() => {
			const payload = {
				type: 'VOID',
				paymentType: 'CREDIT',
				applicationType: 'DVPAYLITE',
				refId: 'INV-POC-001',
				receiptType: 'No'
			};
			return { data: JSON.stringify(payload) };
		})()
	},
	[DejavooActions.BatchClose]: {
		path: 'pay',
		params: (() => {
			const payload = {
				type: 'SETTLE',
				applicationType: 'DVPAYLITE'
			};
			return { data: JSON.stringify(payload) };
		})()
	},
	[DejavooActions.Status]: {
		path: 'pay',
		params: (() => {
			const payload = {
				type: 'STATUS',
				applicationType: 'DVPAYLITE',
				refId: 'INV-POC-001'
			};
			return { data: JSON.stringify(payload) };
		})()
	}
};

export const buildBaseUri = (path, queryParams) => {
	const usp = new URLSearchParams(queryParams);
	return `${DEJAVOO_SCHEME}://${path}?${usp.toString()}`;
};


